<div class="sdp-wizard-navigation-container">
	<div
		class="sdp-wizard-navigation-left sdp-wizard-previous-container"
		*ngIf="previousPage.length !== 0"
	>
		<button
			mat-raised-button
			color="accent"
			(click)="navigateToPage(previousPage);"
			type="submit"
		>{{ 'sdp.label.previous' | translate }}</button>
	</div>
	<div class="sdp-wizard-navigation-right">
		<a
			class="sdp-wizard-navigation-link"
			mat-button
			href="https://impulsepoint.atlassian.net/wiki/spaces/CMKB/pages/428802172/SafeConnect+SDP+Demo+Deployment+Guide"
			target="_blank"
		>{{ "wizard-help-demo-link" | translate }}</a>
		<span *ngIf="!showNext">
			<sdp-skip-wizard></sdp-skip-wizard>
		</span>
		<button
			mat-raised-button
			color="accent"
			(click)="navigateToPage(nextPage);"
			type="submit"
		>{{ getNext()}}</button>
	</div>
</div>